module.exports = __webpack_public_path__ + "static/img/company-component-cove-10-2.c9570f34.jpg";